import React from 'react';

import { flagStyles } from '../settings';

const SvgTM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5256px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTM;
